import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { GET_ACTIVITY, DELETE_ACTIVITY } from "../actions";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

import {
  getActivitySuccess,
  getActivityError,
  trashActivitySuccess,
  trashActivityError,
} from "./actions";

export function* watchGetActivity() {
  yield takeEvery(GET_ACTIVITY, getActivity);
}

export function* watchTrashActivity() {
  yield takeEvery(DELETE_ACTIVITY, trashActivity);
}

const getActivityAsync = async (payload) => {
  try {

    const recordActivityGetReturned = 
    await centralApiAxios.get('activities/'+ payload.activityId, getActivityHeadersUpdated(payload));    

    if (recordActivityGetReturned.data) {
      return {
        activity: recordActivityGetReturned,
        message: null,
      };
    }

    return { message: "Get process failed." };
  } catch (error) {
    return {
      message: "Failed to get process. ",
    };
  }
};

function* getActivity({ payload }) {
  try {
    const returnedData = yield call(getActivityAsync, payload);
    if (!returnedData.message) {
      yield put(
        getActivitySuccess({
          activity: returnedData.activity,
        })
      );
    } else {
      yield put(getActivityError(returnedData.message));
    }
  } catch (error) {
    yield put(getActivityError(error));
  }
}

const trashActivityAsync = async (payload) => {
  try {
    const recordActivityReturned = await centralApiAxios.delete(
      "activities?id=" + payload.activityId + "&trash=true"
    );
    if (recordActivityReturned.data) {
      return {
        successMessage: "Trash Activity was successful.",
        message: null,
      };
    }
    return { message: "Trash Activity failed." };
  } catch (error) {
    return {
      message: "Trash Activity failed.",
    };
  }
};

function* trashActivity({ payload }) {
  try {
    const returnedData = yield call(trashActivityAsync, payload);
    if (!returnedData.message) {
      yield put(trashActivitySuccess(returnedData.successMessage));
    } else {
      yield put(trashActivityError(returnedData.message));
    }
  } catch (error) {
    yield put(trashActivityError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetActivity),
    fork(watchTrashActivity)
  ]);
}
